import AgentsTable from './AgentsTable'

export default AgentsTable
